var $ee2212e66656667f$exports = {};
$ee2212e66656667f$exports = {
    "help": `Hj\xe6lp`,
    "info": `Oplysninger`
};


export {$ee2212e66656667f$exports as default};
//# sourceMappingURL=da-DK.module.js.map
